import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { format, formatDistanceToNow } from 'date-fns';

const NotesList = ({ notes, onDeleteNote }) => {
  if (!notes || notes.length === 0) {
    return (
      <div className="text-xs text-neutral-500 text-center py-3">
        No notes yet. Add one to get started!
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      className="space-y-2 max-h-64 overflow-y-auto custom-scrollbar"
    >
      <AnimatePresence>
        {notes.map((note) => (
          <motion.div
            key={note.id}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            className="bg-neutral-900 border border-neutral-700 rounded p-2 group hover:border-neutral-600 transition-colors"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="text-xs text-neutral-200 break-words">
                  {note.text}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex items-center gap-1 text-xs text-neutral-500">
                    <UserCircleIcon className="h-3 w-3" />
                    <span>{note.createdBy || 'Admin'}</span>
                  </div>
                  <span className="text-xs text-neutral-500">•</span>
                  <span className="text-xs text-neutral-500" title={format(new Date(note.createdAt), 'PPpp')}>
                    {formatDistanceToNow(new Date(note.createdAt), { addSuffix: true })}
                  </span>
                </div>
              </div>
              <button
                onClick={() => onDeleteNote(note.id)}
                className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-neutral-800"
              >
                <XMarkIcon className="h-3 w-3 text-neutral-500 hover:text-red-400" />
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </motion.div>
  );
};

export default NotesList;
